module.exports = globalThis.config = {
    Settings: {
        welcome: {
            en: "Welcome",
            fa: "خوش آمدید"
        },
        img_compress_options: {
            maxSizeMB: 0.8,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            maxIteration: 5,
        },
        max_file_size_options: {
            image: '5 MB',
            video: '10 MB',
            pdf: '1 MB',
            doc: '1 MB',
        },
        Locale: 'en',
        reapplyMaxDuration: 1,
        prehactairFee: 1000,
        prehactairFeeTF: 2000,
        certificateOfOrginVailid: 3,
        certificatePRvailid: 60, // In Month
        ApiConfiguration: {
            //"Appurl": "http://localhost:3000/",
            "Appurl": "https://assamforestwatch.com/",
            //"Host": "http://corp-sqldb/",
            //"Appurl": "https://assamforestwatch.com/",
            "Host": "https://assamforestwatch.com/",
            // "APIGateway": "https://62.171.144.12:4435/api/gateway",
            //"Appurl": "https://portal.rmsi.com/AssamFMIS/",
            //"Host": "https://115.124.116.252/",  
            "HelpURL": "https://assamforestwatch.com/Microservices/FMISHelp/",
            "SSO_urls": {
                "GIS": "https://gis.assamforestwatch.com/",
                "PMIS": "https://pmis.assamforestwatch.com/"
            },
            // "Appurl": "http://localhost/AssamFMIS/",
            // "Host": "http://corp-sqldb/",

            //"Appurl": "https://115.124.116.252/AssamFMIS/",
            //"Host": "https://115.124.116.252/", 

            "BaseURL": "",
            //"BaseURL": "",  
            //"Appurl": "https://geoportal.rmsi.com:4455/",
            // "UploadMaxFiles": 3,
            // "GJSON": {},
            // // "Host": "https://62.171.144.12/",
            //"Host": "https://geoportal.rmsi.com/",

            "User": {
                "UserName": "",
                "jwtToken": "",
                "ExpiredIn": "",
                "userid": "",
                "emailId": "",
                "applicanttype_Id": "",
                "mobile_number": "",
                "userdetail_id": ""
            },
            // "Microservices": {
            //     "Common": "/FMIS_Dev/Common/",
            //     "TOF": "/FMIS_Dev/TOF/",
            //     "WBI": "/FMIS_Dev/WBI/",
            //     "HRMS": "/FMIS_Dev/HRMS",
            //     "VMI": "/FMIS_Dev/VMI",
            //     "OFFENCE": "/FMIS_Dev/OFFENCE",
            //     "FRA": "/FMIS_Dev/FRA",
            //     "Nursery": "/FMIS_Dev/nursery",
            //     "WLMS": "/FMIS_Dev/WLMS",
            //     "UB_Analytics": "/FMIS_Dev/UB_Analytics",
            //     "encroachment": "/FMIS_Dev/encroachment",
            //     "Asset_Management": "/FMIS_Dev/Assetmanagement",
            //     "DigitalLibrary": "/FMIS_Dev/DigitalLibrary",
            //     "CourtCase": "/FMIS_Dev/CourtCase",
            //     "GIS": "/FMIS_Dev/GIS"

            // },
            "Microservices": {
                "Common": "/Microservices/Common/",
                "TOF": "/Microservices/TOF/",
                "WBI": "/Microservices/WBI/",
                "HRMS": "/Microservices/HRMS",
                "VMI": "/Microservices/VMI",
                "OFFENCE": "/Microservices/OFFENCE",
                "FRA": "/Microservices/FRA",
                "Nursery": "/Microservices/nursery",
                "WLMS": "/Microservices/WLMS",
                "UB_Analytics": "/Microservices/UB_Analytics",
                "encroachment": "/Microservices/encroachment",
                "Asset_Management": "/Microservices/Assetmanagement",
                "DigitalLibrary": "/Microservices/DigitalLibrary",
                "CourtCase": "/Microservices/CourtCase",
                "GIS": "/Microservices/GIS",
                "FRRESASSMT": "/Microservices/FRRESASSMT",
                "Patrolling": "/Microservices/patrolling",
            },
            "Permissions": "",
            "Resources": "",
        },
        token: '',
        security_key: '48271710799bc4816a4673a364a130f5e8825bc0d49e57638bd5025240f8e535431ad105a21e6b2235451812acd15ecc3eafd4e1d6fc093d49f34cbabb625e89',
        interval_continiue: 120,
        session_expired: 1800000,
        // interval_continiue: 20,
        // session_expired: 10000,

        // // map Config for Dev
        // MapConfig: {
        //     PortalUrl: "https://geoportal.rmsi.com/arcportal11/",
        //     ID: "f20d570134fa45ce8e6731d33deada45",
        //     IdentifyTaskUrl: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam/ForestBoundaries/MapServer/",
        //     QueryTaskUrl: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam/AdminBoundaries/MapServer/1",
        //     AssamAdminBoundary: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam/AdminBoundaries/MapServer/1",
        //     ForestBoundary: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam/NewForestBoundariesDevelopmentEnv/MapServer",
        //     IncidentsDataLayer: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam/View_WLMS_Incident_List/MapServer/0",
        //     baseURL: 'https://geoportal.rmsi.com/arcportal11/sharing/rest/',
        //     createGISuserUrl: 'https://geoportal.rmsi.com/arcportal11/portaladmin/security/users/createUser',
        //     portalAdminUserName: 'portaladmin',
        //     portalAdminPasswrd: 'Portal11point1',
        //     portalLocalIP: '10.24.1.157:443',
        //     ApiVersion: "4.29"
        // },
        // // map Config for Dev

        //map Config for Staging
        MapConfig: {
            PortalUrl: "https://portal.assamforestwatch.com/gisportal",
            ServerUrl: "https://portal.assamforestwatch.com/gisserver",
            ID: "446cf1a848954f5c98f4c5c6fd440495",
            IdentifyTaskUrl: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/ForestBoundaries_UAT/MapServer/",
            QueryTaskUrl: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/AdminBoundaries_UAT/MapServer/1",
            AssamAdminBoundary: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/AdminBoundaries_UAT/MapServer/1",
            ForestBoundary: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/ForestBoundaries_UAT/MapServer",
            IncidentsDataLayer: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/GIS_vw_Incident_List/MapServer/0",
            baseURL: 'https://portal.assamforestwatch.com/gisportal/sharing/rest/',
            createGISuserUrl: 'https://portal.assamforestwatch.com/gisportal/portaladmin/security/users/createUser',
            Offence_Feature_Service: 'https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/OffenceDetails/MapServer/0',
            vw_NurseyDetailsLayer: 'https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/NurseryDetails/MapServer',
            FeaturesGenerate: 'https://portal.assamforestwatch.com/gisportal/sharing/rest/content/features/generate', //prod
            portalAdminUserName: 'portaladmin',
            portalAdminPasswrd: 'Assam.Forest321',
            portalLocalIP: '115.124.126.221:443',
            ApiVersion: "4.29",
            //Wing wise Division & Range
            Wingwise_Division: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/ForestBoundaryProd_RefView/MapServer/0",
            Wingwise_Range: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/ForestBoundaryProd_RefView/MapServer/1",
            //Wing wise Division & Range
            Plot_Tracker_Tool: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/PlotTrackerTool/GPServer/PlotTrackerTool/execute",
            Plots_layer: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/Plots_layer/FeatureServer/0",
            Required_Plots: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/Plots_layer/FeatureServer/1",
            User_Plots: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/Plots_layer/FeatureServer/2",
            StrataTrackerTool: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/StrataTrackerTool/GPServer/StrataTrackerTool/execute",
            //Patrolling
            Patrolling_Feature_Service: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/PatrollData/FeatureServer/1",
            //Patrolling
        },
        // map Config for Staging

        ModuleMapLayers: {
            FORESTBOUNDARIESURL: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/ForestBoundaries_UAT/MapServer",
            INCIDENTSURL: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-Prod/GIS_vw_Incident_List/MapServer/0",
            DEFORESTATIONALERTURL: "https://portal.assamforestwatch.com/gisserver/rest/services/Assam-UAT/Deforest_Alerts_Observations_UAT/MapServer/0",
            POACHINGURL: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam-STG/vw_Poachers_Details_Stg/MapServer/0",
            ILLEGALTREEFELLINGURL: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam-STG/vw_TreeFelling_Details_STG/MapServer/0",
            ENCROACHMENTURL: "https://arcgisent.rmsi.com/arcserver/rest/services/Assam-STG/vw_Encroachment_Details_Stg/MapServer/0",
        },


        ArcGISUser: {
            publisher: {
                role: "org_publisher",
                usertype: "Publisher"
            },
            editor: {
                role: "org_user",
                usertype: "creatorUT"
            },
            viewer: {
                role: "iAAAAAAAAAAAAAAA",
                usertype: "viewerUT"
            }
        },
        UBA: {
            resource_id: -1,
            permission_id: -1
        },
        max_file_size_options: {
            image: '5 MB',
            video: '10 MB',
            pdf: '1 MB',
            doc: '1 MB',
        },
        "toast_life": 5000
    }
};